export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.'
